import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/api`,
  withCredentials: true,
});

// 'http://localhost:5500/api'

//Auth
export const doLogin = (data) => api.post("/auth/login", data);
export const forgotPassword = (data) => api.post("/auth/forgot", data);
export const resetPassword = (data) => api.patch("/auth/reset", data);
export const dLogout = () => api.get("/auth/logout");

//Admin
export const getCounts = () => api.get("/admin/counts");
export const getEmployees = () => api.get("/admin/employees");
export const getInterns = () => api.get("/admin/interns");
export const getLeaders = () => api.get("/admin/leaders");
export const getFreeLeaders = () => api.get("/admin/leaders/free");
export const getAdmins = () => api.get("/admin/admins");
export const getTeams = () => api.get("/admin/teams");

export const getTeamMembers = (data) => api.get(`/admin/team/${data}/members`);
export const addUser = (data) => api.post("/admin/user", data);
export const deleteUser = (data) => api.post("/admin/deleteUser", data);
export const updateUser = (id, data, userType) => {
  const endpoint =
    userType === "Admin" ? `/admin/user/${id}` : `/employee/user/${id}`;
  return api.patch(endpoint, data);
};
export const addTeam = (data) => api.post("/admin/team", data);
export const updateTeam = (id, data) => api.post(`/admin/team/${id}`, data);
export const getEmployee = (data) => api.get(`/admin/employee/${data}`);
export const getLeader = (data) => api.get(`/admin/leader/${data}`);
export const getFreeEmployees = () => api.get("/admin/employees/free");
export const getTeam = (data) => api.get(`/admin/team/${data}`);
export const removeMember = (data) =>
  api.patch("/admin/team/member/remove", data);
export const addMember = (data) => api.patch("/admin/team/member/add", data);
export const removeLeader = (data) =>
  api.patch("/admin/team/leader/remove", data);
export const addLeader = (data) => api.patch("/admin/team/leader/add", data);
export const getUser = (id, userType) => {
  const endpoint =
    userType === "Admin" ? `/admin/user/${id}` : `/employee/user/${id}`;
  return api.get(endpoint);
};
export const getAttendance = (data) =>
  api.post("admin/view-employee-attendance", data);
export const updateAttendence = (data) =>
  api.post("/admin/updateAttendence", data);
export const viewLeaves = (data) =>
  api.post("admin/view-leave-applications", data);
export const updateLeave = (id, data) =>
  api.post(`admin/update-leave/${id}`, data);
export const assignSalary = (data) =>
  api.post("admin/assign-employee-salary", data);
export const updateSalary = (data) =>
  api.post("admin/update-employee-salary", data);
export const viewAllSalaries = (data) =>
  api.post("admin/view-all-salary", data);
export const createNotice = (data) => api.post("admin/create-notices", data);
export const getNotices = () => api.get("admin/get-notices");
export const updateNotice = (id, data) =>
  api.patch(`admin/notices/${id}`, data);
export const deleteNotice = (id) => api.delete(`admin/notices/${id}`);
export const assignBulkSalary = (data) =>
  api.post("admin/assign-bulk-salary", data);
export const getAttendanceSummary = (data) =>
  api.post("admin/getAttendanceSummaries", data);
export const updateAttendanceSummary = (data) =>
  api.post("admin/updateAttendanceSummary", data);
export const getEmployeeLeaveSummary = (data) =>
  api.post("admin/employeeLeaveSummary", data);
export const uploadHolidays = (data) =>
  api.post("/admin/upload-holidays", data);

//Leader
export const getMembers_Leader = () => api.get("/leader/team/members");
export const getTeam_Leader = () => api.get("/leader/team/");
export const getTeamMembersLeaveApplications = (leaderID) =>
  api.get(`/leader/team/${leaderID}/leave-applications`);
export const teamMemberViewLeaves = (data) =>
  api.post("/leader/view-leave-applications", data);
export const updateLeaderLeaveApplication = (id, data) =>
  api.post(`/leader/update-leave/${id}`, data);
export const getTeamMembersLeaveApplicationsByLeader = (leaderID) =>
  api.get(`/team/${leaderID}/leave-applications`);

// Employee
export const getEmployeeTeam = (data) => api.get(`/employee/team/${data}`);
export const getEmployeeTeamMembers = (data) =>
  api.get(`/employee/team/${data}/members`);
export const markEmployeeAttendance = (data) =>
  api.post("/employee/mark-employee-attendance", data);
export const markEmployeeCheckIn = (data) =>
  api.post("/employee/mark-employee-checkin", data);
export const markEmployeeCheckOut = (data) =>
  api.post("/employee/mark-employee-checkout", data);
export const viewEmployeeAttendance = (data) =>
  api.post("/employee/view-employee-attendance", data);
export const applyforleave = (data) =>
  api.post("/employee/apply-leave-application", data);
export const viewLeaveApplications = (data) =>
  api.post("/employee/view-leave-applications", data);
export const viewEmployeeSalary = (data) =>
  api.post("employee/view-salary", data);
export const viewEmployeeMonthlySalary = (data) =>
  api.post(`employee/employee-salary`, data);

export const fetchNotices = () => api.get("employee/get-notices");
export const bulkCheckIn = (data) => api.post("/admin/bulk-attendance", data);

// Intern
export const getInternTeam = (data) => api.get(`/intern/team/${data}`);
export const getInternTeamMembers = (data) =>
  api.get(`/intern/team/${data}/members`);
export const markInternAttendance = (data) =>
  api.post("/intern/mark-intern-attendance", data);
export const markInternCheckIn = (data) =>
  api.post("/intern/mark-intern-checkin", data);
export const markInternCheckOut = (data) =>
  api.post("/intern/mark-intern-checkout", data);
export const viewInternAttendance = (data) =>
  api.post("/intern/view-intern-attendance", data);
export const applyForInternLeave = (data) =>
  api.post("/intern/apply-leave-application", data);
export const viewInternLeaveApplications = (data) =>
  api.post("/intern/view-leave-applications", data);
export const viewInternSalary = (data) => api.post("intern/view-salary", data);
export const viewInternMonthlySalary = (data) =>
  api.post(`intern/intern-salary`, data);

export const fetchInternNotices = () => api.get("intern/get-notices");

// Add these new API functions
export const submitInternReport = (data) =>
  api.post("/intern/create-report", data);
export const getAllReports = () => api.get("/admin/get-all-report");
export const getReportsByEmployee = (employeeId) =>
  api.get(`/intern/report/${employeeId}`);
export const getFilteredReports = (params) =>
  api.get("/admin/get-filtered-report", { params });

// Jobs API
export const createJob = (data) => api.post("/jobs", data);
export const getJobs = (params) => api.get("/jobs", {
  params,
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0'
  }
});
export const updateJob = (id, data) => api.put(`/jobs/${id}`, data);
export const submitJobForApproval = (id) => api.post(`/jobs/${id}/submit-for-approval`);
export const approveJob = (id, data) => api.post(`/jobs/${id}/approve`, data);
export const rejectJob = (id, data) => api.post(`/jobs/${id}/reject`, data);
export const publishJobInternally = (id) => api.post(`/jobs/${id}/publish/internal`);
export const publishJobExternally = (id, data) => api.post(`/jobs/${id}/publish/external`, data);
export const closeJob = (id) => api.post(`/jobs/${id}/close`);

// Candidates API
export const createCandidate = (data) => api.post("/candidates", data);
export const getAllCandidates = (params) => api.get("/candidates", { params });
export const getCandidateById = (id) => api.get(`/candidates/${id}`);
export const updateCandidate = (id, data) => api.put(`/candidates/${id}`, data);
export const addCandidateNote = (id, data) => api.post(`/candidates/${id}/notes`, data);

api.interceptors.response.use(
  (response) => {
    console.log("All Cookies", document.cookie);
    // Return both data and status to preserve success information
    return {
      ...response.data,
      status: response.status
    };
  },
  (error) => {
    console.log(error);
    return error.response.data;
  }
);

export default api;
